<div class="risk-main">
  <div class="col-lg-12 row">
    <div class="col-lg-2"></div>
    <div class="col-lg-8">
    <div class="text-center heading-main p-3">Risk Factors</div>
    <div class="risk-data" *ngFor="let item of riskData.section1">
      <div class="heading-sub  pt-3 pl-3">
        {{item.heading}}
      </div>
      <div class="risk-content p-3">
        {{item.content}}
      </div>
    </div>
    <div class="standard-factors mb-4">
        <div class="col-lg-12 row pl-0">
            <div class="col-lg-5 text-center">
       <div class="heading-standard  p-2 mb-4"> <h2 class="pt-3">Standard Risk Factors</h2></div>
       </div>
       <div class="col-lg-7"></div>
    </div>
       <li class="risk-content"  *ngFor="let item of riskData.section2">
        {{item.content}}
       </li>
    </div>
    </div>
    <div class="col-lg-2"></div>
  </div>
</div>
